<template>
  <div :class="bem()" v-bind="bind_container">
    <span class="label" v-for="pool in poolsFiltered"
    :key="pool.name">
      {{ pool.name }} <button aria-hidden="true" class="v-icon material-icons theme--light" @click.prevent="clearPool(pool.pool_id)">cancel</button>
    </span>
    <span class="label" v-for="refinement in searchStore.activeRefinements.reverse()"
    :key="refinement.attributeName + refinement.name">
      {{ getRefinementStr(refinement)}} <button aria-hidden="true" class="v-icon material-icons theme--light" @click.prevent="clear(refinement)">cancel</button>
    </span>
  </div>
</template>

<script>
import format from 'date-fns/format'
import fromUnixTime from 'date-fns/fromUnixTime'
import { Component } from 'vue-instantsearch'
import { createNamespacedHelpers } from 'vuex'
import POOLS from '@/graphql/Pools.gql'
const { mapState, mapMutations } = createNamespacedHelpers('searchEnginePage')

export default {
  name: 'aisCurrentrefinements',
  mixins: [Component],
  props: {
    attributeLabels: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      pools: [],
      blockClassName: 'ais-current-refinements'
    }
  },
  computed: {
    ...mapState(['checkedPools', 'authenticated']),
    poolsFiltered () {
      const checkedPoolIds = Object.keys(this.checkedPools).reduce((ids, id) => {
        return this.checkedPools[id] ? [ ...ids, parseInt(id) ] : ids
      }, [])
      return this.pools ? this.pools.filter(p => checkedPoolIds.indexOf(p.pool_id) > -1 ? p : false) : []
    },
    bind_container () {
      const binding = {}
      if (this.searchStore.activeRefinements.length > 0 || this.poolsFiltered.length > 0) binding.style = 'margin-bottom: 10px;'
      return binding
    }
  },
  methods: {
    ...mapMutations(['setCheckedPools']),
    clear (refinement) {
      if (refinement.type === 'disjunctive' || refinement.type === 'hierarchical') {
        this.searchStore.clearRefinements(refinement.attributeName, refinement.name)
        return
      }
      if (refinement.type !== 'numeric') {
        this.searchStore.toggleFacetRefinement(refinement.attributeName, refinement.name)
      } else {
        this.searchStore.clearRefinements(refinement.attributeName, refinement.name)
      }
    },
    clearPool (poolId) {
      let checkedPoolsTmp = Object.assign({}, this.checkedPools)
      checkedPoolsTmp[poolId] = false
      this.setCheckedPools(checkedPoolsTmp)

      this.searchStore.page = 1
      this.searchStore.refresh()
    },
    getLabel (label) {
      // transform 'smartTag' in 'Smart tag'. 'airport_name' in 'Airport name'
      return this.attributeLabels[label] || `${label.charAt(0).toUpperCase()}${label.slice(1).replace(/([A-Z])/g, ' $1').replace('_', ' ')}`
    },
    getRefinementStr (refinement) {
      let value = refinement.name
      let facetLabel = this.getLabel(refinement.attributeName)
      if (refinement.type === 'facet' && facetLabel.slice(-2) === '.n') {
        return `${facetLabel.slice(0, -2)}: ${value}`
      } else if (refinement.type !== 'numeric') {
        return `${facetLabel}: ${value}`
      } else {
        if (refinement.attributeName.search('(date)') && refinement.name.toString().length === 10) {
          value = format(fromUnixTime(refinement.name), 'yyyy-MM-dd')
        }
        return `${facetLabel} ${refinement.operator} ${value}`
      }
    }
  },
  apollo: {
    pools: {
      query: POOLS,
      skip () {
        return !this.authenticated
      }
    }
  }
}
</script>
<style>

.ais-current-refinements .label {
  border: 1px solid #ff9800;
  color: #ff9800;
  background-image: initial;
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-repeat-x: initial;
  background-repeat-y: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  margin: 2px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 19px;
  cursor: default;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 32px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 10px 9px;
  vertical-align: middle;
  white-space: nowrap;
  z-index: 1;
}
.ais-current-refinements button {
  margin-left:5px;
  color: #ff9800 !important;
}

</style>
